import React from 'react';
import { Table, TableHead, TableBody, TableCell, TableRow, Paper, TableContainer } from '@mui/material';
import { CustomerDownloadModel } from 'store/types/Customer';

import './TableComponent.scss';

type Props = {
  data?: string;
  value: CustomerDownloadModel[];
};
type State = object;
export default class TextAreaComponent extends React.Component<Props, State> {
  public render(): JSX.Element {
    return (
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell component="th" scope="row">
                <b>Document Name</b>
              </TableCell>
              <TableCell align="right">
                <b>Order Date</b>
              </TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right">
                <b></b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.value.map((row) => (
              <TableRow key={row.downloadId}>
                <TableCell component="th" scope="row">
                  {row.docName}
                </TableCell>
                <TableCell align="right">{row.publishDate}</TableCell>
                {row.standards === 'Yes' ? (
                  <TableCell>
                    <a
                      className="btn active btn-outline-success"
                      href={row.downloadUrl}
                      target="_blank"
                      style={{ marginRight: '8px' }}
                      rel="noreferrer"
                    >
                      Download
                    </a>
                    <a className="btn active btn-outline-success" target="_blank" href={row.viewerUrl} rel="noreferrer">
                      View
                    </a>
                  </TableCell>
                ) : (
                  <TableCell>
                    <a className="btn active btn-outline-success" href={row.downloadLink}>
                      Download
                    </a>
                  </TableCell>
                )}
                {/* {row.standards === 'Yes' ? (
                  <TableCell align="right">
                    <a className="btn active btn-outline-success" target="_blank" href={row.viewerUrl}>
                      View
                    </a>
                  </TableCell>
                ) : (
                  <TableCell align="right"></TableCell>
                )} */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}
